import TEMP_INDEX_MAPPING, { TEMP_INDEX } from '@/constants/weatherTempIndex.js'

export default (idx) => TEMP_INDEX_MAPPING[idx] || TEMP_INDEX_MAPPING[TEMP_INDEX.MILD]